import { render, staticRenderFns } from "./AwaitingMakeup.vue?vue&type=template&id=73768afa&scoped=true"
import script from "./AwaitingMakeup.vue?vue&type=script&lang=js"
export * from "./AwaitingMakeup.vue?vue&type=script&lang=js"
import style0 from "./AwaitingMakeup.vue?vue&type=style&index=0&id=73768afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73768afa",
  null
  
)

export default component.exports